import React from 'react'
import ButtonYapp from '../Buttons/ButtonYapp'

const InputButtonDiscount = ({
  btnText,
  error,
  onApply,
  onRemove,
  setDiscountCode,
  discountCode,
  titleButton,
  ...props
}) => {
  return (
    <>
      <div className="position-relative input-yapp">
        <div className="content-input-bg">
          <input
            style={{cursor: props.discount && 'auto'}}
            type="text"
            value={discountCode}
            readOnly={props.discount ? true : false}
            className="input-custom-secondary font-regular w-100"
            placeholder="Ingresar código"
            onChange={(inputText) => setDiscountCode(inputText.target.value)}
            {...props}
          />
          {props.discount ? (
            <div className="mw-115 position-absolute input-btn-position d-flex align-items-center justify-content-end flex-fill">
              {/* Remove discount
                <i className="icon-close txt-1--bold mr-2 txt-red" onClick={ onRemove }></i> */}
              <i className="icon-circle-check txt-1--bold mr-2 color-theme"></i>
            </div>
          ) : (
            <ButtonYapp
              title={titleButton || 'Aplicar'}
              onClick={onApply}
              color={'--theme-color'}
              className="z-index-99 mw-115 position-absolute input-btn-position"
              noWrap
              small
            />
          )}
        </div>
        {error && (
          <p className="txt-6--regular-er mt-1 mb-2">{error.message}</p>
        )}
      </div>
    </>
  )
}

export default InputButtonDiscount
